import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import './style/index.scss'
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard)

import ElementUI from 'element-ui'
Vue.use(ElementUI)

import AOS from 'aos'
import '../node_modules/aos/dist/aos.css'

import animated from 'animate.css'
Vue.use(animated)

import 'element-ui/lib/theme-chalk/display.css'
import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'
import qs from 'qs' 
Vue.prototype.$axios= axios
Vue.prototype.$qs = qs

// 注册图片工具插件
import ImagePlugin from './plugins/imagePlugin'
Vue.use(ImagePlugin)

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined?'渲酷云渲染平台_云端在线渲染农场_3dsmax渲染_效果图渲染_3d渲染平台 -您身边的渲染专家':to.meta.title
  window.scrollTo(0,0)
  next()
})


new Vue({
  created() {
    AOS.init()
  },
  router,
  strict: false, // 关闭严格模式
  render: h => h(App)
}).$mount("#app")
